import { RegisterableHotkey } from '@tanstack/react-hotkeys';
import { HOTKEY_ACTIONS, HotkeyActionId } from './hotkeyActions';
import { useHotkeyOverrides } from './hotkeySettings';

/**
 * Resolves an action id to the user's keybinding, or its default,
 */
export function useHotkeyBinding(actionId: HotkeyActionId): RegisterableHotkey | null {
  const [overrides] = useHotkeyOverrides();
  if (actionId in overrides) {
    return overrides[actionId] ?? null;
  }
  return HOTKEY_ACTIONS[actionId].defaultHotkey ?? null;
}
